import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PageBanner from '../components/common/PageBanner';
import { Section, Head, Index, SideImage } from '../components/common/Primitives';
import { experiences } from '../data/site';
import banner from '../assets/banners/experiences.jpg';
import visitorLanes from '../assets/farm/visitor-lanes.jpg';

const Experiences = () => (
  <div>
    <PageBanner
      image={banner}
      kicker="Experiences"
      title="Tours, dinners and workshops"
      lead="Membership is not limited to produce. It is an entry into a set of experiences that connect you to your food, the farm, and the people growing it."
    />

    <Section tone="paper">
      <Head
        eyebrow="What members get invited to"
        title="Three ways in"
        center
      />
      <div className="mt-14 grid md:grid-cols-3 gap-6">
        {experiences.map((e, i) => (
          <article
            key={e.title}
            className="rounded-2xl bg-chalk ring-1 ring-soil/10 overflow-hidden flex flex-col"
          >
            <img
              src={e.image}
              alt={e.title}
              className="w-full h-52 object-cover"
            />
            <div className="p-7 flex flex-col flex-1">
              <div className="flex items-center gap-3">
                <Index n={i + 1} />
                <h3 className="font-display font-semibold text-[1.35rem] text-ink">{e.title}</h3>
              </div>
              <p className="mt-3.5 text-soil/70 text-[14.5px] leading-relaxed">{e.description}</p>
            </div>
          </article>
        ))}
      </div>
    </Section>

    <Section tone="soil">
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Head
            tone="dark"
            eyebrow="Open door"
            title="Come and see the system running"
            lead="A farm tour is not a marketing walk. You can stand in the growing lanes, look at the live readings coming off the trays, and ask the agronomists why a particular zone was dosed this morning."
          />
          <div className="mt-9 flex flex-wrap gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-lime text-ink px-7 py-3.5 font-semibold hover:bg-paper transition-colors"
            >
              Arrange a visit <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/farm-tech/system"
              className="inline-flex items-center gap-2 rounded-full ring-1 ring-white/20 px-7 py-3.5 font-medium text-paper hover:ring-lime hover:text-lime transition-colors"
            >
              See the system first
            </Link>
          </div>
        </div>
        <SideImage
          tone="dark"
          src={visitorLanes}
          alt="A crate of greens carried past visitors on the greenhouse floor"
        />
      </div>
    </Section>

    <Section tone="paper">
      <div className="max-w-3xl mx-auto text-center">
        <Head
          eyebrow="Members only"
          title="These are not open to the public"
          lead="Experiences are reserved for the 500, though members can extend invitations to friends and family at preferential rates."
          center
        />
        <Link
          to="/membership"
          className="inline-flex items-center gap-2 mt-10 rounded-full bg-forest text-paper px-7 py-3.5 font-semibold hover:bg-ink transition-colors"
        >
          Request membership <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </Section>
  </div>
);

export default Experiences;
